// Thank You Redirect Handler
// Функція для редіректу на thank-you сторінку після успішної відправки замовлення

// Функція для визначення поточної мови
function getCurrentLanguage() {
  const path = window.location.pathname;
  const langMatch = path.match(/^\/([a-z]{2})\//);
  return langMatch ? langMatch[1] : 'en';
}

// Функція для створення та показу лоадера
export function showRedirectLoader(messageText) {
  // Перевіряємо, чи лоадер вже існує
  const existing = document.getElementById('redirect-loader');
  if (existing) {
    const messageEl = existing.querySelector('.redirect-loader__message');
    if (messageEl && messageText) messageEl.textContent = messageText;
    return;
  }

  // Створюємо лоадер
  const loader = document.createElement('div');
  loader.id = 'redirect-loader';
  loader.className = 'redirect-loader';

  loader.innerHTML = `
    <div class="loader-spinner-container">
      <div class="loader-dots">
        <div class="loader-dot"></div>
        <div class="loader-dot"></div>
        <div class="loader-dot"></div>
        <div class="loader-dot"></div>
      </div>
      <div class="loader-spinner"></div>
    </div>
    <div class="loader-progress"></div>
    <div class="redirect-loader__message">${
      messageText || 'Please wait...'
    }</div>
  `;

  document.body.appendChild(loader);

  // Показуємо лоадер з анімацією
  setTimeout(() => {
    loader.classList.add('active');
  }, 100);
}

export function hideRedirectLoader() {
  const loader = document.getElementById('redirect-loader');
  if (!loader) return;
  loader.classList.remove('active');
  setTimeout(() => {
    loader.remove();
  }, 150);
}

// Функція редіректу на thank-you сторінку
export function redirectToThankYou() {
  // Показуємо лоадер
  showRedirectLoader();

  const language = getCurrentLanguage();
  window.location.href = `/${language}/thank-you.html`;
}
